"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UserDto_1 = require("./Protocol/UserDto");
class InitialState {
    constructor(u) {
        this.user = u.user || UserDto_1.UserDto.INVALID_USER;
        this.friends = u.friends || [];
    }
    toString() {
        return JSON.stringify(this);
    }
}
exports.InitialState = InitialState;
//# sourceMappingURL=InitialState.js.map